import { getIntegrationDetails } from 'components/Previews/getIntegrationDetails'
import Styles from './LinkedinChrome.module.scss'
import { PlatformChromeProps } from './Types'
import { Avatar } from './Avatar'
import { Earth } from 'components/Previews/FacebookPreview/icons'
import { LikeIcon, CommentIcon, RepostIcon, SendIcon } from 'components/Previews/LinkedinPreview/icons'

export const LinkedinChrome = ({ children, integration, caption }: PlatformChromeProps) => {
  const { picture, username } = getIntegrationDetails(integration)

  return (
    <div className={Styles.chrome}>
      <div className={Styles.header}>
        <Avatar picture={picture} className={Styles.avatar} />
        <div className={Styles.accountInfo}>
          <div className={Styles.username}>{username}</div>
          <div className={Styles.metadata}>
            <div>Head of Awesome at Blaze.ai</div>
            <div>
              <span>1m</span> <span>•</span> <span>Edited</span> <span>•</span> <Earth size={8} />
            </div>
          </div>
        </div>
      </div>
      <div className={Styles.captionContainer}>
        <div className={Styles.caption} dangerouslySetInnerHTML={{ __html: caption || '' }} />
      </div>
      {children}
      <div className={Styles.footer}>
        <LikeIcon size={14} />
        <CommentIcon size={14} />
        <RepostIcon size={14} />
        <SendIcon size={14} />
      </div>
    </div>
  )
}
